<template>
  <BaseSimpleCard title="">
  <BaseSimpleTab :tabs="tabs" />
  <div class='mt-5'>
    <router-view></router-view>
  </div>
  </BaseSimpleCard>
</template>

<script>

export default {
  name: 'TheInvoicingShowPage',
  data() {
    return {
      tabs: [
        {label: this.$t('global.general_information'), icon: 'info-square', routeName: 'invoice_info_route'},
        {label: this.$t('global.activities'), icon: 'file-alt', routeName: 'invoice_activity_route'},
      ]
    }
  }
}
</script>
